import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { data } from 'src/app/audit-trail/application/data';
import { ApiUrls } from 'src/app/services/ApiUrls';

@Injectable({
  providedIn: 'root'
})
export class EscalationDurationService {
  loadGrievanceType(): any {
    throw new Error('Method not implemented.');
  }

  constructor(public httpClient:HttpClient) { }

 //submit rest
 async submitEscalationDuration(data: any) {
  return new Promise((resolve) => {
    this.httpClient
      .post(ApiUrls.createEscalationDuration, data)
      .toPromise()
      .then((res) => {
        resolve(res);
      })
      .catch((resp: Response) => {
        resolve(resp);
      });
  });
}
//


  //submit rest
  async deleteEscalationDuration(pkEsId: any) {
    const data = {
      'gEsId': pkEsId
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.deleteGrievanceEscalation, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


    //get one grievance type rest
    async getOneGrievanceEscalation(data: any) {
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.getOneGrievanceEscalation, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //
    

    //get one grievance type rest
    async updateGrievanceEscalation(data: any) {
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.updateGrievanceEscalation, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //

    async getAllGrievanceEscalation(id:any) {
      
      const data={'fkGtId':id}
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.getAllGrievanceEscalation,data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }

    //load board rest
  async loadBoard() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadBoard, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load departments type rest
  async loadDepartments(boardId: any) {
    const data = { 'bdId': boardId, };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadDepartment, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


}
